import ProductCategoriesList from './ProductCategoriesList';

export default ProductCategoriesList;
